import i18n from '@/lang/i18n'
import TaskForm from './components/TaskForm/TaskForm.vue'
import TaskDelete from './components/TaskDelete/TaskDelete.vue'
import TaskArchive from './components/TaskArchive/TaskArchive.vue'

const modals: KwixeoInterface.DynamicModals = [
  {
    key: 'task-form',
    title: task => task && task.id ? 'tasks.editTitle' : 'tasks.addTitle',
    component: TaskForm,
    size: 'lg',
    buttons: [
      {
        if: (value: KwixeoInterface.GenericObject) => value?.id !== undefined,
        component:  TaskDelete,
        useValue: true,
        attributes: {
          variant: 'primary',
          element: 'button'
        },
        events: {
          deleted: (args: void, close: () => void): void => {
            close()
          }
        }
      },
      {
        if: (value: KwixeoInterface.GenericObject) => value?.id !== undefined,
        component:  TaskArchive,
        useValue: true,
        attributes: {
          variant: 'secondary',
          element: 'button'
        },
        events: {
          archived: (args: void, close: () => void): void => {
            close()
          }
        }
      },
      {
        if: (value: KwixeoInterface.GenericObject) => value?.id !== undefined,
        separator: true
      },
      {
        label: i18n.t('interface.cancel') as string,
        variant: 'secondary',
        click: (modal: KwixeoInterface.DynamicModal, events: KwixeoInterface.DynamicModalButtonEvents): void => events.close()
      },
      {
        label: i18n.t('interface.save') as string,
        variant: 'primary',
        click: (modal: KwixeoInterface.DynamicModal, events: KwixeoInterface.DynamicModalButtonEvents): void => events.ok()
      }
    ]
  }
]

export default modals
